import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Alert,
  Spinner,
} from 'reactstrap';
import Header from '../../components/Headers/Header.js';
import { axiosGet, axiosPut } from '../../util/apiConfig';

const NUMERIC_FIELDS = ['price50', 'price25', 'priceTrial', 'noShowValue', 'conversionIncentive'];

class PayoutSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price50: '',
      price25: '',
      priceTrial: '',
      noShowMode: 'flat',
      noShowValue: '',
      conversionIncentive: '',
      defaultTimeZone: 'Asia/Kolkata',
      loading: true,
      saving: false,
      successMsg: '',
      errorMsg: '',
    };
  }

  componentDidMount() {
    axiosGet('payout/settings')
      .then((res) => {
        const s = res && res.data;
        if (s) {
          this.setState({
            price50: s.price50 ?? '',
            price25: s.price25 ?? '',
            priceTrial: s.priceTrial ?? '',
            noShowMode: s.noShowMode || 'flat',
            noShowValue: s.noShowValue ?? '',
            conversionIncentive: s.conversionIncentive ?? '',
            defaultTimeZone: s.defaultTimeZone || 'Asia/Kolkata',
          });
        }
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handleChange = (field) => (e) => {
    this.setState({ [field]: e.target.value, successMsg: '', errorMsg: '' });
  };

  save = () => {
    this.setState({ saving: true, successMsg: '', errorMsg: '' });
    const payload = {
      noShowMode: this.state.noShowMode,
      defaultTimeZone: this.state.defaultTimeZone,
    };
    NUMERIC_FIELDS.forEach((f) => {
      payload[f] = this.state[f] === '' ? 0 : Number(this.state[f]);
    });
    axiosPut('payout/settings', payload)
      .then((res) => {
        this.setState({ saving: false, successMsg: res.message || 'Saved' });
      })
      .catch((err) => {
        this.setState({ saving: false, errorMsg: (err && err.message) || 'Could not save settings' });
      });
  };

  render() {
    const { loading, saving, successMsg, errorMsg, noShowMode } = this.state;
    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">Payout Settings</h3>
                  <small className="text-muted">
                    Rates apply to every teacher. Used by the monthly payout calculation.
                  </small>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <>
                      {successMsg ? <Alert color="success">{successMsg}</Alert> : null}
                      {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <label className="form-control-label">Price per 50-min class</label>
                            <Input type="number" value={this.state.price50} onChange={this.handleChange('price50')} />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <label className="form-control-label">Price per 25-min class</label>
                            <Input type="number" value={this.state.price25} onChange={this.handleChange('price25')} />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <label className="form-control-label">Price per trial (demo) class</label>
                            <Input type="number" value={this.state.priceTrial} onChange={this.handleChange('priceTrial')} />
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <label className="form-control-label">Conversion incentive (per conversion)</label>
                            <Input type="number" value={this.state.conversionIncentive} onChange={this.handleChange('conversionIncentive')} />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <label className="form-control-label">Student no-show pay mode</label>
                            <Input type="select" value={noShowMode} onChange={this.handleChange('noShowMode')}>
                              <option value="flat">Flat amount</option>
                              <option value="percent">Percent of class rate</option>
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <label className="form-control-label">
                              {noShowMode === 'percent' ? 'No-show percent (%)' : 'No-show amount'}
                            </label>
                            <Input type="number" value={this.state.noShowValue} onChange={this.handleChange('noShowValue')} />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <label className="form-control-label">Default timezone</label>
                            <Input type="text" value={this.state.defaultTimeZone} onChange={this.handleChange('defaultTimeZone')} placeholder="Asia/Kolkata" />
                          </FormGroup>
                        </Col>
                      </Row>
                      {noShowMode === 'percent' ? (
                        <small className="text-muted d-block mb-3">
                          Percent applies to that class&apos;s rate — a 50-min no-show pays this % of the 50-min price, a 25-min no-show this % of the 25-min price.
                        </small>
                      ) : null}
                      <Button color="primary" onClick={this.save} disabled={saving}>
                        {saving ? 'Saving…' : 'Save settings'}
                      </Button>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default PayoutSetting;
